import type { DecorativeTagColorType } from '../types/decorativeTagColor.type';

export const DECORATIVE_TAG_CLASSES: { [key in DecorativeTagColorType]: string } = {
  celeste: 'border-decorative-border-celeste bg-decorative-background-celeste',
  lilac: 'border-decorative-border-lilac bg-decorative-background-lilac',
  lavender: 'border-decorative-border-lavender bg-decorative-background-lavender',
  vanilla: 'border-decorative-border-vanilla bg-decorative-background-vanilla',
  aqua: 'border-decorative-border-aqua bg-decorative-background-aqua',
  tea: 'border-decorative-border-tea bg-decorative-background-tea',
  champagne: 'border-decorative-border-champagne bg-decorative-background-champagne',
  sahara: 'border-decorative-border-sahara bg-decorative-background-sahara',
  mint: 'border-decorative-border-mint bg-decorative-background-mint',
  peach: 'border-decorative-border-peach bg-decorative-background-peach',
  misty: 'border-decorative-border-misty bg-decorative-background-misty'
};
